

export const baseURL= 
  "https://admin.houseofdhanushdhari.com/api/" 
 


export const auth={
   login: baseURL+"renovate/login",
   register:baseURL+'renovate/register',
   getProfile:baseURL+'renovate/profile',
  
}



export const property={
   
   getProperty:baseURL+'renovate-property',
   // getGallery:baseURL+'real-estate/gallery',
   // sendEnquiry:baseURL+'real-estate-property-enquiry',
   orderProperty:baseURL+'renovate/create-order',
   verifyPayment:baseURL+'renovate/verify-payment'
}

